const $user = {
  state: {
    userName: '管理员1',
    userId: '',
    sessionId: '',
    // 当前激活的菜单
    activeMenu: '',
    // 当前tab列表
    tabList: [],
    // 当前tab激活的格
    tabActive: '1'
  },
  mutations: {
    GET_USERNAME: (state, data) => {
      state.userName = data;
    },
    GET_USERID: (state, data) => {
      state.userId = data;
    },
    GET_SESSIONID: (state, data) => {
      state.sessionId = data;
    },
    set_active_menu: (state, data) => {
      state.activeMenu = data;
    },
    set_tab_list: (state, data) => {
      state.tabList = data;
    },
    set_tab_active: (state, data) => {
      state.tabActive = data;
    }
  },
  actions: {
    GetUserName ({
      commit
    }, data) {
      commit('GET_USERNAME', data);
    },
    GetUserId ({
      commit
    }, data) {
      commit('GET_USERID', data);
    },
    GetSessionId ({
      commit
    }, data) {
      commit('GET_SESSIONID', data);
    }
  }
};

export default $user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js